import { memo, useEffect, useState } from 'react';
import HomeCard from './HomeCard';
import WorkCalendar from './WorkCalendar';
import StatisticsList from './StatisticsList/StatisticsList';
import StatisticsVerticalList from './StatisticsList/StatisticsVerticalList';
import { connect } from 'umi';
import './index.less';
import { holiday } from '@/_assets/json/holiday';
import { useReactive } from 'ahooks';
import { getByDateRange } from '@/_serveice/usercenter';
import CommonUse from './CommonUse';

const Employee = ({ dispatch, usercenter, loadingEf }) => {
  let roleList =
    JSON.parse(localStorage.getItem('employeeDTO'))?.roleTypeList || [];
  const state = useReactive({
    holidayData: holiday,
  });
  useEffect(() => {
    let empId = localStorage.getItem('muId');
    dispatch({
      type: 'usercenter/getEmpHomeWork',
      payload: {
        empId,
      },
    });
    dispatch({
      type: 'usercenter/getEmpWorkRptList',
      payload: {
        empIdString: localStorage.getItem('muId'),
        rptBeginTime: moment()
          .subtract(1, 'month')
          .startOf('M')
          .format('YYYY-MM-DD'),
        rptEndTime: moment().format('YYYY-MM-DD'),
      },
    });

    const currentYear = new Date().getFullYear();
    const startDate = moment().startOf('year').format('YYYY-MM-DD');
    const endDate = moment().endOf('year').format('YYYY-MM-DD');
    if (currentYear) {
      dispatch({
        type: 'usercenter/getholidaybyyear',
        payload: { year: currentYear },
      }).then(async (res) => {
        const updatedHolidayData = {};
        Object.keys(res || {}).forEach((key) => {
          const newKey = `${currentYear}-${key}`;
          updatedHolidayData[newKey] = res[key];
        });
        let newRes = await getByDateRange({
          startDate,
          endDate,
        });
        if (newRes?.data) {
          Object.keys(newRes.data).forEach((dateKey) => {
            const activities = newRes.data[dateKey];
            if (activities && activities.length > 0) {
              // 提取所有活动的名称作为child数组
              const child = activities.map((activity) => activity.remark);
              const startDate = activities.map((activity) =>
                activity.startDate
                  ? moment(activity.startDate).format('HH:mm')
                  : '',
              );
              const endDate = activities.map((activity) =>
                activity.endDate
                  ? moment(activity.endDate).format('HH:mm')
                  : '',
              );
              // 检查是否有假期（isHoliday == 1）
              const hasHoliday = activities.some(
                (activity) => activity.isHoliday == 1,
              );
              // 取第一个活动的名称作为主名称
              const mainName = activities[0].name;

              updatedHolidayData[dateKey] = {
                date: dateKey,
                holiday: hasHoliday,
                name: mainName,
                child: child,
                startDate: startDate,
                endDate: endDate,
              };
            }
          });
        }
        if (res) {
          state.holidayData = { ...state.holidayData, ...updatedHolidayData };
        }

        console.log(
          'updatedHolidayData...',
          updatedHolidayData,
          state.holidayData,
        );
      });
    }
  }, []);

  return (
    <>
      {/* <div style={{ borderRadius: 8, marginBottom: 20 }}>
        <div className="home-card-title">个人工作台</div>
        <HomeCard data={usercenter.homeWork} />
      </div> */}

      <div className="employee-main">
        <div className="layout-left">
          <WorkCalendar
            data={usercenter.homeEmpWorkRptList?.list}
            homeHoliday={state.holidayData}
          />
        </div>

        <div className="layout-right">
          <div className="layout-right-top">
            <CommonUse />
          </div>

          <div className="layout-right-bottom">
            <StatisticsVerticalList
              roleList={roleList}
              usercenter={usercenter}
              dispatch={dispatch}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(({ usercenter, loading }) => ({
  usercenter,
  loadingEf: loading.effects,
}))(Employee);
